/* eslint-disable import/no-unresolved */
/* eslint-disable import/namespace */
import "../../assets/style/style.css";
import "../../assets/style/variable.css";
import "../../assets/js/all.min.js";
import React from "react";
import {  NavLink } from "react-router-dom";
import {LoginLeft} from "../../components/LoginLeft";
import { useForm } from "react-hook-form";
import { FormError } from "../../components/FormError";
import { yupResolver } from "@hookform/resolvers/yup"
import { login, reset, setUserData } from "../../slices/AuthSlice"
import { Loading } from "../../components/Loading";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { MessageModel } from "../../components/MessageModel"
import {useNavigate } from "react-router-dom"
import * as Yup from "yup"

export function Login(){
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.auth.loading);
  const authSlice = useSelector((state) => state.auth);
  //const [authData, setAuthData] = useState({})
  const validationSchema = Yup.object().shape({
    email:Yup.string()
      .email("Please enter vaild email")
      .required("Please enter email"),
    password: Yup.string().required("Please enter"),
  });
  const { register, handleSubmit,
    formState: { errors } } = useForm({
    mode:"onBlur",
    resolver: yupResolver(validationSchema)
  });
  
  useEffect(()=>{
    //dispatch(getPermissions())
    if(authSlice?.authData?.user 
      && Object.keys(authSlice?.authData?.user)?.length > 0){
      //setAuthData(authSlice.authData)
      //const { isMaster } = authSlice?.authData?.user
      dispatch(setUserData({...authSlice.authData, isLoggedIn:true}))
      navigate("/dashboard", { replace: true })
      // if(isMaster){
      //   navigate("/dashboard", { replace: true })
      // }else{
      //   navigate("/shopping-partners/retailers", { replace: true })
      // }
      
    }
  }, [authSlice.authData, authSlice.authData?.user, dispatch, navigate])

  const onSubmit = function(data){
    dispatch(login(data))
  };

  const btnOk = () => {
    dispatch(reset())
  }
  return (
    <React.Fragment>
      { loading && <Loading/>  }
      <section className="trasnBG-form logincenter">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-center h-100">
            <LoginLeft/>
            <div className="col-xl-4 col-lg-4 col-sm-12 col-12 formcontainer">
              <div className="form-content">
                <div className="fomrHeader">
                  <h1>Welcome to Prem Green</h1>
                </div>
                <div className="formDiv">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label htmlFor="password" className={`input-label ${errors.email && "error"}`}>Email</label>
                      <input 
                        type="email" 
                        name="email" 
                        {...register("email")} 
                        className={`input-txt form-control ${errors.email && "error"}`} 
                        placeholder="Email" />
                      {errors.email && <FormError message={errors.email.message} />}
                    </div>
                    <div className="form-group">
                      <div className="d-flex align-items-center justify-content-between">
                        <label htmlFor="password" className={`input-label ${errors.password && "error"}`}>Password</label>
                      </div>
                      <input 
                        {...register("password")} 
                        type="password" 
                        name="password" 
                        className={`input-txt form-control ${errors.password && "error"}`} placeholder="*******" />
                      {errors.password && <FormError message={errors.password.message} />}
                    </div>
                    
                    <div className="form-group">
                      <button type="submit" className="btn-log">Sign in</button>
                    </div>
                  </form>
                
                  <ul className="socialList">
                    <li>
                      <NavLink to={"#"}><i className="fab fa-google-plus-g" /></NavLink>
                    </li>
                                
                    <li>
                      <NavLink to={"#"}><i className="fab fa-facebook-f" /></NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      { authSlice.errors || authSlice.success?
          <MessageModel 
            btnEvent={btnOk}
            success = {authSlice.success?true:false}  
            message={authSlice.errors || authSlice.success}  
        />:""}
    </React.Fragment>
  )

} 